<template>
  <div class="themeItem_leagueTable_container">
    <div class="tableScrollArea" ref="tableParentDom">
      <compreSportsMeet_table
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :parentWidthPx="parentWidthPx"
        :isScrollFlag="themeItem.renderTable.isScrollFlag"
        :variableColWidthVw="themeItem.renderTable.variableColWidthVw"
        :tableCellDefaultWidthVw="themeItem.renderTable.tableCellDefaultWidthVw"
        :defaultWidthVwNum="themeItem.renderTable.defaultWidthVwNum"
        :tableColumnData="themeItem.renderTable.tableColumnData"
        :tableData="themeItem.renderTable.tableData"
        :isBroadCastList="true"
        :tableHeightPx="tableHeightPx"
        v-show="themeItem && themeItem.renderTable.tableData.length > 0"
        :tableMode="tableMode"
      ></compreSportsMeet_table>
      <!-- <p class="noDataClass" v-show="noData">暂无数据</p> -->
    </div>
  </div>
</template>

<script>
// 奖牌榜 主题  【支持竖向滚动】
import cup_base_data_mixin from '@mixins/cup_base_data'
import compreSportsMeet_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
export default {
  name: 'themeItem_leagueTable_container',
  mixins: [cup_base_data_mixin],
  components: {
    compreSportsMeet_table,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('html_leageuTable 重新刷新数据:', newVal, oldVal)
        if (newVal && newVal.data) {
          this.themeItem = this.computedTableData(newVal)
        }
      },
      immediate: false,
      deep: true,
    },
  },
  data() {
    return {
      tableMode: 'combat_groupStage none',
      parentWidthPx: 0,
      themeItem: null,
    }
  },
  computed: {
    tableHeightPx() {
      // 等比的，所以固定写死
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375
      return Math.floor((clientWidth / 100) * (2.638 * 5.4 + 3.332))
      //   return 'auto'
    },
  },
  created() {
    console.debug('this.datas:', this.datas)
    this.themeItem = this.computedTableData(this.datas)
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
    this.$nextTick(() => {
      this.onResizeEvent()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
        console.debug('dom 存在')
        // this.tableHeightPx = this.$refs.tableParentDom.offsetHeight
      } else {
        console.debug('dom 不存在')
      }
      console.debug('this.tableHeightPx:', this.tableHeightPx)
    },
    computedTableData(item) {
      let table_header = null

      const table = item
      let label = ''
      let tableData = []
      if (item.graphicsId === 11) {
        // 足球世界杯
        let statisticsModels = JSON.parse(JSON.stringify(item.statisticsModels))
        table_header = statisticsModels ? statisticsModels.splice(4) : null
        tableData = table.data.dataList
          ? table.data.dataList.map((team) => {
              team.team_id = team.teamId
              team.rank_num = team.rankNum
              team.team_name = team.teamName
              team.team_logo = team.teamLogo

              return team
            })
          : []
        label = item.data.seriesName
      } else if (item.graphicsId === 3018) {
        // 综合性赛事
        table_header = item.statisticsModels ? item.statisticsModels : null
        tableData = table.data.dataList[0]
          ? table.data.dataList[0].ranks.map((team) => {
              team.team_id = team.organisationCode
              team.rank_num = team.rankNum
              team.team_name = team.organisationName
              team.team_logo = team.organisationLogo

              return team
            })
          : []
        label =
          item.data.dataList && item.data.dataList[0]
            ? item.data.dataList[0].groupName
            : ''
      } else if (item.graphicsId === 4001) {
        // 羽毛球 汤尤杯
        let statisticsModels = JSON.parse(JSON.stringify(item.statisticsModels))
        table_header = statisticsModels ? statisticsModels : null
        tableData = table.data.dataList
          ? table.data.dataList.map((team) => {
              team.team_id = team.teamId
              team.rank_num = team.rankNum
              team.team_name = team.teamName
              team.team_logo = team.teamLogo

              return team
            })
          : []
        label = item.data.seriesName
      }

      let otherTableColumnData = []
      if (table_header) {
        otherTableColumnData = table_header.map((keyItem) => {
          return {
            prop: keyItem.statisticalEn,
            label: keyItem.name,
            widthVw: 5.55,
          }
        })
      }

      const tableColumnData = [].concat(
        [
          {
            prop: 'rankNum-teamLogo-teamName',
            label,
            widthVw: 25.42,
            className: 'columnNumLogoNameClass',
            fixed: 'left',
          },
        ],
        otherTableColumnData
      )

      item.renderTable = {
        isScrollFlag: false,
        variableColWidthVw: 20.83, // 可变化的宽度
        tableCellDefaultWidthVw: 5.55, // 默认宽度 ,
        defaultWidthVwNum: otherTableColumnData.length,
        tableColumnData,
        tableData: tableData,
        analysisItemId: table.analysisItemId,
        json: table.json,
        seasonOrMatch: table.seasonOrMatch,
        title: table.title,
      }
      return item
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.themeItem_leagueTable_container {
  width: 100%;
  padding: 0.694vw 0;
  .tableScrollArea {
    width: 100%;
  }
}
</style>
